<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 查询 -->
    <div class="pd-8 bg-white">
      <el-form :inline="true" ref="form" :model="form" label-width="120px">
        <el-form-item label="区域名称">
          <el-input
            clearable
            v-model="form.name"
            placeholder="请输入区域名称"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="是否禁用">
          <el-select
            clearable
            v-model="form.status"
            placeholder="请选择是否禁用"
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item> -->

        <!-- 这里需要一个多选框，选择多个设备类型 -->
        <el-form-item label="拥有设备类型">
          <el-select
            clearable
            v-model="serverIdArr"
            placeholder="请选择拥有设备类型"
            multiple
            :multiple-limit="5"
          >
            <el-option label="社区售水机" value="1"></el-option>
            <el-option label="楼宇单元售水机" value="2"></el-option>
            <el-option label="家用净水器" value="3"></el-option>
            <el-option label="户外/公共冰热温净饮机" value="4"></el-option>
            <el-option label="管道纯净水入户" value="5"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <btns class="mgb-20" @exec="exec"></btns>

    <!-- 表格 -->
    <el-table border :data="tableData" stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="regionName" label="区域名称"> </el-table-column>
      <el-table-column prop="regionDesc" label="区域简介">
        <template slot-scope="scope">
          <span
            v-text="scope.row.regionDesc ? scope.row.regionDesc : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="区域地址">
        <template slot-scope="scope">
          <span v-text="scope.row.remark ? scope.row.remark : '- -'"></span>
        </template>
      </el-table-column>

      <el-table-column prop="state" label="是否禁用">
        <template slot-scope="scope">
          <span v-text="scope.row.status == 1 ? '启用' : '禁用'"></span>
        </template>
      </el-table-column>

      <el-table-column prop="remark" label="拥有设备类型">
        <template slot-scope="scope">
          <span
            v-for="(type, index) in String(scope.row.serverId).split('/')"
            :key="index"
          >
            <span v-if="type === '1'">社区售水机</span>
            <span v-else-if="type === '2'">楼宇单元售水机</span>
            <span v-else-if="type === '3'">家用净水器</span>
            <span v-else-if="type === '4'">户外/公共冰热温净饮机</span>
            <span v-else-if="type === '5'">管道纯净水入户</span>

            <!-- 如果不是最后一个，添加顿号 -->
            <span
              v-if="
                scope.row.serverId &&
                  index < String(scope.row.serverId).split('/').length - 1
              "
              >、</span
            >
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="remark" label="设备数量">
        <template slot-scope="scope">
          <span v-text="scope.row.deviceNum"></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <el-button type="text" size="small" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="handleDel(scope.row)"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status == 0"
            @click="handleEnable(scope.row)"
            >启用</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status == 1"
            @click="handleEnable(scope.row)"
            >禁用</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 创建和编辑弹框 -->
    <el-dialog
      :title="type === 1 ? '创建分区' : '编辑分区'"
      :visible.sync="dialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-form
        ref="addEditForm"
        :rules="rules"
        :model="addEditForm"
        label-width="120px"
      >
        <el-form-item label="区域名称" prop="name">
          <el-input
            v-model="addEditForm.name"
            placeholder="请输入区域名称"
            maxlength="20"
            show-word-limit
            :disabled="type !== 1"
          ></el-input>
        </el-form-item>

        <el-form-item label="拥有设备类型" prop="serverId">
          <el-select
            clearable
            v-model="addEditForm.serverId"
            placeholder="请选择拥有设备类型"
            multiple
            :multiple-limit="5"
          >
            <el-option label="社区售水机" value="1"></el-option>
            <el-option label="楼宇单元售水机" value="2"></el-option>
            <el-option label="家用净水器" value="3"></el-option>
            <el-option label="户外/公共冰热温净饮机" value="4"></el-option>
            <el-option label="管道纯净水入户" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域简介">
          <el-input
            type="textarea"
            v-model="addEditForm.desc"
            placeholder="请输入区域简介"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="区域地址">
          <el-input
            type="textarea"
            v-model="addEditForm.address"
            placeholder="请输入区域地址"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        style="color: var(--danger);margin-top: 10px;margin-bottom: 10px;"
        v-if="type == 1"
      >
        温馨提示:分区创建后不允许修改名称或删除，请谨慎操作。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="sure('addEditForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns
  },
  data() {
    // 新增联系方式验证
    const name = (rule, value, callback) => {
      var reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/;
      if (!value) {
        callback(new Error("请输入区域名称"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持中英文、数字输入"));
      } else {
        callback();
      }
    };

    const serverId = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error("请至少选择一个设备类型"));
      } else {
        callback(); // 验证通过
      }
    };
    return {
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 15, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {},
      tableData: [],
      dialogVisible: false,
      addEditForm: {
        name: "",
        desc: "",
        address: "",
        serverId: []
      },
      rules: {
        name: [{ required: true, validator: name, trigger: "blur" }],
        serverId: [{ required: true, validator: serverId, trigger: "change" }]
      },
      type: null,
      id: null,
      serverIdArr: []
    };
  },
  created() {
    this.getList();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    }
  },
  methods: {
    // 创建编辑确认按钮
    sure(d) {
      this.$refs[d].validate(valid => {
        if (valid) {
          handleConfirm("确认保存吗?", "info")
            .then(() => {
              if (this.type === 1) {
                this.$api.zone
                  .addZone({
                    regionName: this.addEditForm.name,
                    regionDesc: this.addEditForm.desc,
                    remark: this.addEditForm.address,
                    serverId: this.addEditForm.serverId.join("/")
                  })
                  .then(res => {
                    if (res.code === 200) {
                      handleAlert("保存成功", "success");
                      this.dialogVisible = false;
                      this.getList();
                    }
                  });
              } else {
                this.$api.zone
                  .editZone({
                    id: this.id,
                    regionName: this.addEditForm.name,
                    regionDesc: this.addEditForm.desc,
                    remark: this.addEditForm.address,
                    serverId: this.addEditForm.serverId.join("/")
                  })
                  .then(res => {
                    if (res.code === 200) {
                      handleAlert("保存成功", "success");
                      this.dialogVisible = false;
                      this.getList();
                    }
                  });
              }
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 删除分区
    handleDel(row) {
      handleConfirm(`确认删除分区<${row.regionName}>吗?`, "info")
        .then(() => {
          this.$api.zone.delZone({ id: row.id }).then(res => {
            if (res.code === 200) {
              handleAlert("删除成功", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // 区域列表
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.zone
        .zoneList({
          pageNum: this.page,
          pageSize: this.pageSize,
          regionName: this.form.name,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          serverIds: this.serverIdArr
        })
        .then(res => {
          if (res.code === 200) {
            res.data.list.forEach(v => {
              if (v.serverDeviceNum) {
                JSON.parse(v.serverDeviceNum).forEach(v2 => {
                  if (v2.serverId == 1) {
                    v.deviceNum = v2.deviceNum;
                  }
                });
              } else {
                v.deviceNum = 0;
              }
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },

    // 创建分区
    setZone() {
      this.type = 1;
      this.addEditForm = {
        name: "",
        desc: "",
        address: "",
        serverId: []
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addEditForm.clearValidate();
      });
    },

    // 编辑分区
    handleEdit(row) {
      this.id = row.id;

      this.type = 2;
      this.addEditForm.name = row.regionName;
      this.addEditForm.desc = row.regionDesc ? row.regionDesc : "";
      this.addEditForm.address = row.remark ? row.remark : "";
      this.addEditForm.serverId = row.serverId
        ? String(row.serverId).split("/")
        : [];
      this.dialogVisible = true;
      console.log("点击编辑分区", this.addEditForm);
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addEditForm.clearValidate();
      });
    },

    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;

      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;

      this.getList(this.page);
    },

    // 分区详情
    handleDetail(row) {
      this.$router.push({
        path: "/zoneManage/zoneInfo",
        query: {
          zoneId: row.id,
          companyId: row.companyId
        }
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    changeServerId(val) {
      console.log(val);
      // 现在获取到的数据是这样的 ['1', '2', __ob__: Observer] 我需要的是这样的 “1/2”
      let serverId = val.join("/");
      this.form.serverId = serverId;
      console.log("选中", this.form.serverId);
    },
    handleEnable(row) {
      console.log("row", row);
      // return
      // 这里不需要做判断
      // const actionText = row.status == 0 ? "启用" : "禁用";
      handleConfirm(
        "确认" + (row.status == 0 ? "启用" : "禁用") + "该分区吗?",
        "info"
      )
        .then(() => {
          this.$api.zone
            .editZone({
              id: row.id,
              status: row.status == 0 ? 1 : 0
            })
            .then(res => {
              if (res.code === 200) {
                handleAlert("保存成功", "success");
                this.getList();
              }
            });
        })
        .catch(() => {
          return;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
